import React, {useEffect, useRef} from 'react';
import styles from './ExploreSectionDown.module.scss'
import ArrowDown from "components/icons/arrowDown/ArrowDown";
import panelStyles from "components/homePanels/Panels.module.scss";
import {gsap} from "gsap";
import {useDispatch, useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";

const ExploreSectionDown = (props) => {

    const accessible = useSelector(state => state.accessible);
    const animationCount = useSelector(state => state.animationCount);
    const dispatch = useDispatch()
    const button = useRef();
    const downArrow = useRef();
    const panelData = useSelector(state => state.panelData);

    useEffect(()=>{

        setTimeout(()=>{

        /** status is needed to prevent flash of arrow on "next panel" in macro sections **/
        if(downArrow.current && button.current && props.status === "active") {

            /** skip is set at end of panel ("next panel"), where we want to make sure the animation does not happen **/
            if (accessible.exploring && props.content && props.content.current && props.content.current.parentNode) {

                gsap.to(button.current, {duration: 0.6, scale: 0, opacity: 0})
                gsap.to(downArrow.current, {delay: 0.6, duration: 0.6, height: '180px'})
                gsap.to(props.content.current.parentNode, {delay: 0.8, duration: 2, scrollTo: props.content.current.offsetTop})

            } else {
                gsap.to(button.current, {duration: 0, scale: 1, opacity: 1})
                gsap.to(downArrow.current, {duration: 0, height: 0})
            }
        }

        }, 100)

    }, [panelData,  props.content, props.status, accessible.exploring]);


    function clickAction(){
        if(animationCount === 0){
            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    exploring: true,
                    topExit: true
                }
            });
        }
    }

    function buildClass(){
        return `explore ${panelStyles.explore} ${panelStyles.button} ${props.dark ? panelStyles.white : panelStyles.black} ${props.macro === 'Martellus' ? panelStyles.whiteBg : ''}`
    }

    return (
        <>
            <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'}
                  aria-label={props.cta} onKeyDown={buttonClick} ref={button} onClick={()=>clickAction()} className={buildClass()}>
                <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:props.cta}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
            </span>
            <div ref={downArrow} className={`downArrow ${styles.downArrow}`}>
                <ArrowDown fill={props.dark ? '#fff' : '#000'}/>
            </div>
        </>
    )
};

export default ExploreSectionDown
